import { useState, useEffect, useCallback, useMemo } from 'react';
import userSessionService from '../services/UserSessionService';

/**
 * Hook pour gérer la session utilisateur
 * @returns {Object} État de la session utilisateur
 */
export function useUserSession() {
  const [user, setUser] = useState(userSessionService.getUser());
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    userSessionService.isUserAuthenticated()
  );
  const [isLoading, setIsLoading] = useState(userSessionService.isLoading());

  // Vérifier la session utilisateur au montage
  useEffect(() => {
    const initSession = async () => {
      // Essayer de capturer le token depuis l'URL (callback OAuth)
      userSessionService.initFromUrl();

      // Vérifier le token auprès du serveur
      const verifiedUser = await userSessionService.verify();

      setUser(verifiedUser);
      setIsUserAuthenticated(userSessionService.isUserAuthenticated());
      setIsLoading(false);
    };

    initSession();
  }, []);

  // Fonction de déconnexion
  const logout = useCallback(async () => {
    await userSessionService.logout();
    setUser(null);
    setIsUserAuthenticated(false);
  }, []);

  // Fonction de vérification manuelle
  const refreshSession = useCallback(async () => {
    setIsLoading(true);
    const verifiedUser = await userSessionService.verify();
    setUser(verifiedUser);
    setIsUserAuthenticated(userSessionService.isUserAuthenticated());
    setIsLoading(false);
  }, []);

  const sessionMethods = useMemo(
    () => ({
      isTwitchConnected:
        userSessionService.isTwitchConnected.bind(userSessionService),
      isSpotifyConnected:
        userSessionService.isSpotifyConnected.bind(userSessionService),
      getTwitchUser: userSessionService.getTwitchUser.bind(userSessionService),
      getSpotifyUser:
        userSessionService.getSpotifyUser.bind(userSessionService),
      connectTwitch: userSessionService.connectTwitch.bind(userSessionService),
      connectSpotify:
        userSessionService.connectSpotify.bind(userSessionService),
      disconnectTwitch:
        userSessionService.disconnectTwitch.bind(userSessionService),
      disconnectSpotify:
        userSessionService.disconnectSpotify.bind(userSessionService),
    }),
    []
  );

  return {
    user,
    isUserAuthenticated,
    isLoading,
    logout,
    refreshSession,
    ...sessionMethods,
  };
}
